var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"floating-button-filter-text"},[_vm._v("FILTRAR"+_vm._s(_vm.filtersNum ? (" (" + _vm.filtersNum + ")") : ''))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0dfe716","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FloatingButton.vue
// module id = null
// module chunks = 